import React from 'react';
import './index.css';
import logoGold from '../../images/home-landing-page/logo-gold.png';
import TwitterIcon from '../../images/home-landing-page/twitter-icon.png';
import InstaIcon from '../../images/home-landing-page/insta-icon.png';
import YoutubeIcon from '../../images/home-landing-page/youtube-icon.png';
import LinkedinIcon from '../../images/home-landing-page/linkedin-icon.png';

function Footer()
{
    return (
        <div>
            <footer class="footer">
                <div class="top-bg-bar">
                </div>

                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="footer-logo-social">
                                <figure>
                                    <img src={logoGold} />
                                </figure>

                                <div class="social-media-footer">
                                    <label>Social Media</label>
                                    <div class="social-media-list">
                                        <a href="javascript:void(0)" class="media-icon twitter-media">
                                            <img src={TwitterIcon} />
                                        </a>
                                        <a href="javascript:void(0)" class="media-icon insta-media">
                                            <img src={InstaIcon} />
                                        </a>
                                        <a href="javascript:void(0)" class="media-icon youtube-media">
                                            <img src={YoutubeIcon} />
                                        </a>
                                        <a href="javascript:void(0)" class="media-icon linkedin-media">
                                            <img src={LinkedinIcon} />
                                        </a>
                                    </div>
                                </div>
                            </div>


                            <div class="footer-links-wrapper">
                                <div class="footer-links-box">
                                    <h4>
                                        Quick Links
                                    </h4>

                                    <div class="footer-links-list-main">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">For Home Owners</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">For Professionals</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Jobs</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Social Media</a>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Prices</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Education Resources</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Contact</a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div class="footer-link-seprator"></div>

                                <div class="footer-links-box">
                                    <h4>
                                        Directory
                                    </h4>
                                    <div class="footer-links-list-main">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Airconditioning</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Builders</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Concreters</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Design</a>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Estimators</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Gardeners</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">More...</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="footer-link-seprator"></div>
                                <div class="footer-links-box">
                                    <h4>
                                        Resources
                                    </h4>
                                    <div class="footer-links-list-main">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Terminology</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Flow Charts</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Design Tips</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">How to's</a>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Support</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Our Process</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Resource Library</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-copyright text-center">
                                <p>
                                    © 2024 Build Start. All rights reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer
